import { createSlice } from '@reduxjs/toolkit';

const initialGoodsCategoryState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    goodsCategoryForEdit: undefined,
    lastError: null,
};

export const callTypes = {
    list: 'list',
    action: 'action',
};

export const goodsCategorySlice = createSlice({
    name: 'goodsCategory',
    initialState: initialGoodsCategoryState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },

        // getGoodsCategoryById
        goodsCategoryFetched: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.goodsCategoryForEdit = action.payload.goodsCategoryForEdit;
        },
        // findGoodsCategory
        goodsCategorysFetched: (state, action) => {
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
        },
        // Set to default state actionLoading & error
        goodsCategoryReload: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.error = null;
        },

    },
});

